import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\GetNewModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/GetNewModelNotificationController.php
* @route '/api/model-notification/new'
*/
const GetNewModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNewModelNotificationController.url(options),
    method: 'get',
})

GetNewModelNotificationController.definition = {
    methods: ["get","head"],
    url: '/api/model-notification/new',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ModelNotification\GetNewModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/GetNewModelNotificationController.php
* @route '/api/model-notification/new'
*/
GetNewModelNotificationController.url = (options?: RouteQueryOptions) => {
    return GetNewModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\GetNewModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/GetNewModelNotificationController.php
* @route '/api/model-notification/new'
*/
GetNewModelNotificationController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetNewModelNotificationController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ModelNotification\GetNewModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/GetNewModelNotificationController.php
* @route '/api/model-notification/new'
*/
GetNewModelNotificationController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetNewModelNotificationController.url(options),
    method: 'head',
})

export default GetNewModelNotificationController